.haze {
  position: absolute;
  inset: -15%;
  background:
    radial-gradient(
      ellipse at 18% 44%,
      color-mix(in srgb, currentColor 19%, transparent),
      transparent 42%
    ),
    radial-gradient(
      ellipse at 74% 63%,
      color-mix(in srgb, currentColor 12%, transparent),
      transparent 38%
    );
  animation: haze 15s ease-in-out infinite alternate;
}
.pressure {
  display: none;
}
.band {
  position: absolute;
  right: -15%;
  left: -15%;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    color-mix(in srgb, currentColor 32%, transparent),
    transparent
  );
  animation: band 10s ease-in-out infinite alternate;
}
.bandOne {
  top: 32%;
}
.bandTwo {
  top: 67%;
  animation-delay: -4s;
}
.bandThree {
  top: 49%;
  animation-delay: -7s;
  opacity: 0.55;
}
.drift {
  position: absolute;
  width: clamp(0.34em, 0.9cqw, 0.7em);
  height: clamp(0.34em, 0.9cqw, 0.7em);
  border: 1px solid color-mix(in srgb, currentColor 78%, transparent);
  border-radius: 50%;
  box-shadow: 0 0 0.55em color-mix(in srgb, currentColor 55%, transparent);
  animation: drift 11s ease-in-out infinite alternate;
}
.driftOne {
  top: 25%;
  left: 12%;
}
.driftTwo {
  top: 72%;
  left: 58%;
  width: 0.34em;
  height: 0.34em;
  animation-duration: 14s;
  animation-delay: -4s;
  opacity: 0.6;
}
.driftThree {
  top: 18%;
  left: 74%;
  width: 0.7em;
  height: 0.7em;
  animation-duration: 17s;
  animation-delay: -9s;
  opacity: 0.55;
}
.driftFour {
  top: 58%;
  left: 31%;
  width: 0.42em;
  height: 0.42em;
  animation-duration: 9s;
  animation-delay: -2s;
  opacity: 0.75;
}
.driftFive {
  top: 84%;
  left: 83%;
  width: 0.58em;
  height: 0.58em;
  animation-duration: 13s;
  animation-delay: -6s;
  opacity: 0.45;
}
@container running-field (max-width: 40rem) or (max-height: 6rem) {
  .drift,
  .band {
    display: none;
  }
  .haze {
    inset: auto 0 0 auto;
    width: 2.5em;
    height: 2.5em;
    opacity: 0.65;
  }
}
[data-overdue="true"] .haze {
  inset: -30%;
  background:
    radial-gradient(
      ellipse at 22% 48%,
      color-mix(in srgb, currentColor 34%, transparent),
      transparent 42%
    ),
    radial-gradient(
      ellipse at 78% 58%,
      color-mix(in srgb, currentColor 25%, transparent),
      transparent 36%
    );
}
[data-overdue="true"] .pressure {
  display: block;
  position: absolute;
  inset: 20% 0;
  border-top: 1px solid color-mix(in srgb, currentColor 65%, transparent);
  border-bottom: 1px solid color-mix(in srgb, currentColor 65%, transparent);
  background: repeating-linear-gradient(
    180deg,
    transparent 0 0.55em,
    color-mix(in srgb, currentColor 14%, transparent) 0.55em 0.62em
  );
  opacity: 0.75;
  animation: pressure 3.4s ease-in-out infinite alternate;
}
[data-overdue="true"] .band {
  background: linear-gradient(90deg, transparent, currentColor, transparent);
  animation-name: storm-band;
}
[data-overdue="true"] .drift {
  transform: translate(12cqw, -2cqh) scale(0.82);
}
@keyframes haze {
  to {
    transform: translate(9%, -4%);
  }
}
@keyframes band {
  to {
    transform: translateX(8%);
    opacity: 0.45;
  }
}
@keyframes drift {
  to {
    transform: translate(10cqw, -2cqh);
  }
}
@keyframes pressure {
  from {
    transform: scaleY(0.72);
    opacity: 0.45;
  }
  to {
    transform: scaleY(1.12);
    opacity: 0.9;
  }
}
@keyframes storm-band {
  to {
    transform: translateX(-14%);
    opacity: 0.9;
  }
}
@media (prefers-reduced-motion: reduce) {
  [data-overdue="true"] .pressure,
  .haze,
  .band,
  .drift {
    animation: none;
  }
  .pressure {
    animation: none;
  }
}
